
import { defineComponent } from "vue";
import Dialog from "primevue/dialog";
import { mapState } from "vuex";
import moment from "moment";

export default defineComponent({
  name: "InfoDialog",
  components: {
    Dialog,
  },
  props: {
    visibility: Boolean,
  },
  emits: ["update:visibility"],
  data() {
    return {
      currentYear: moment().year(),
      currentVersion: process.env.VUE_APP_VERSION,
    };
  },
  methods: {
    closeDialog() {
      this.$emit("update:visibility", false);
    },
  },
  computed: {
    ...mapState({
      user: "user",
      configurations: "configurations",
    }),
  },
});
